import LiberarPedidosCompra from './componentes/LiberarPedidosCompra.vue';
import LiberarPedidosCompraLista from './componentes/Lista.vue';
import LiberarPedidosCompraRelatorio from './componentes/LiberarPedidosCompraRelatorio.vue';

export default {
  path: '/liberar-pedidos-compra',
  component: LiberarPedidosCompra,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: LiberarPedidosCompraLista,
      name: 'liberar-pedidos-compra',
    },
    {
      path: ':id/relatorio',
      component: LiberarPedidosCompraRelatorio,
      name: 'liberar-pedidos-compra.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-pedidos-compras/rotas.js